import React from 'react'
import { useSelector } from 'react-redux'
import { selectMyPageIds, selectSharedWithMePageIds } from './pagesSlice'

import { List, ListItem, Divider, Typography } from '@mui/material'

import AddPage from './AddPage'
import DeletePage from './DeletePage'
import PageLink from './PageLink'
import ShareOffers from '../shares/ShareOffers'
import RemoveSharedPage from '../shares/RemoveSharedPage'

export default function PagesPane({ currentPageId }) {
  const myPages = useSelector(selectMyPageIds)
  const sharedWithMe = useSelector(selectSharedWithMePageIds)

  // `removable` adds "Remove from my pages" to each entry, which belongs on the
  // pages other people shared with me and not on my own: mine are deleted, not
  // removed, and that is `DeletePage` at the bottom.
  const pageLinks = (pageIds, { removable = false } = {}) =>
    pageIds.map((pageId) => (
      <PageLink
        key={`page-link-${pageId}`}
        pageId={pageId}
        currentPageId={currentPageId}
        action={
          removable ? (
            <RemoveSharedPage pageId={pageId} currentPageId={currentPageId} />
          ) : null
        }
      />
    ))

  return (
    <React.Fragment>
      <AddPage />
      <Divider />
      <List>
        <ListItem>
          <Typography variant='h6'>My pages</Typography>
        </ListItem>
        {myPages.length > 0 ? pageLinks(myPages) : <ListItem>No pages yet</ListItem>}
      </List>

      {/* Offers I haven't answered, above the pages they would become. They are
          not in the groups below, because a page nobody has accepted is kept out
          of the pages list altogether. */}
      <ShareOffers />

      {/* Pages other people have shared with me, kept apart from my own so that
          it is clear at a glance which are which. The heading only appears when
          there are some. */}
      {sharedWithMe.length > 0 && (
        <React.Fragment>
          <Divider />
          <List>
            <ListItem>
              <Typography variant='h6'>Shared with me</Typography>
            </ListItem>
            {pageLinks(sharedWithMe, { removable: true })}
          </List>
        </React.Fragment>
      )}

      <Divider />
      <DeletePage pageId={currentPageId} />
    </React.Fragment>
  )
}
